var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"elevation":"3","color":"info"},on:{"click":_vm.refreshTable}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fa-sync-alt")]),_vm._v(" Actualizar ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }